export default function Hero() {
  return (
    <section
      id="top"
      className="relative bg-ink pt-24 md:pt-36 pb-16 md:pb-20 overflow-hidden"
    >
      <div
        className="absolute inset-0"
        style={{
          backgroundImage:
            "linear-gradient(rgba(245,234,211,0.05) 1px, transparent 1px), linear-gradient(90deg, rgba(245,234,211,0.05) 1px, transparent 1px)",
          backgroundSize: "56px 56px",
        }}
      ></div>

      <div className="relative max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="max-w-full md:max-w-[60%]">
          <h1 className="text-cream font-serif text-3xl md:text-[44px] leading-tight md:leading-[1.15] font-semibold">
            If your product carries an organic claim in an export market, the
            ingredient certification has to hold up in destination. Ours does.
          </h1>

          <p className="mt-6 text-cream/80 text-lg md:text-xl leading-relaxed">
            Mesa Baja supplies organic unrefined whole cane sugar and organic
            cocoa powder as ingredients, from a plant certified by Ecocert for
            USDA and EU Organic, with HACCP and INVIMA registration. Certificate
            of analysis per batch. Full specification below, no form required.
          </p>

          <div className="mt-8 flex flex-col sm:flex-row gap-3">
            <a
              href="#quote"
              className="whitespace-nowrap inline-flex items-center justify-center px-6 py-3.5 rounded-md bg-brand text-white text-base font-semibold hover:bg-brand-dark transition-colors"
            >
              Request spec sheet &amp; CoA
            </a>
            <a
              href="#certification"
              className="whitespace-nowrap inline-flex items-center justify-center px-6 py-3.5 rounded-md border border-cream/40 text-cream text-base font-semibold hover:bg-cream/10 transition-colors"
            >
              Download technical data sheets
            </a>
          </div>

          <div className="mt-10 inline-flex items-center gap-x-3 flex-wrap border border-cream/20 rounded-md px-5 py-3 bg-cream/5">
            <span className="font-mono text-xs md:text-sm text-cream/70 tracking-tight">
              Ecocert USDA &amp; EU Organic · HACCP · INVIMA
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}